<div class="upsell-entry-popup">
  <general-upgrade-modal #upsellEntryPopup *ngIf="isPopupVisible" [featureKeyName]="getFlagVariation"
    componentName="feature-upgrade" getQuoteProductInterestKey="" upsellKey="">
  </general-upgrade-modal>
</div>
